import React, { useEffect } from 'react'
import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { resetPassword, tokenChecker } from '../../asiosConfig';
import { Alert, Box, Button, Card, CardContent, Container, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { resetPasswordValidationSchema } from '../ValidationSchema';
import Footer from '../Footer';
import logo from "../../images/logo.png";
import { Visibility, VisibilityOff } from '@mui/icons-material';

export const SetPassword = () => {

    const { token } = useParams();
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [tokenStatus, setTokenStatus] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkToken = async () => {
            try {
                const response = await tokenChecker({ token });
                if (response.status === 200 || response.status === 201) {
                    setTokenStatus('valid');
                }

            } catch (error) {
                const errorMessage = error.response?.data?.error || 'Invalid token';
                setTokenStatus(errorMessage.includes('expired') ? 'expired' : 'invalid');
            }
        };
        checkToken();
    }, [token]);
    console.log(tokenStatus);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            console.log(values);

            const response = await resetPassword({ token, password: values.password, password_confirmation: values.confirmPassword });

            setMessage(response.data.message);
            setSuccess(true);
            setTimeout(() => navigate('/login'), 2000);
        } catch (error) {
            setMessage(error.response.data.error);
            setSuccess(false);
        } finally {
            setSubmitting(false);
        }
    }
    return (
        <>
            <div className="fixed-top loginTopBG">
                <div className="container d-flex justify-content-between align-items-between">
                    <div className="logo">
                        <a href="#"
                        ><img src={logo} className="img-fluid" alt="logo-img"
                            /></a>
                    </div>
                    <div className="accountBtn">
                        <a href="/login" className="btn loginBtn">LOGIN</a>
                        <Link to="/" className="btn regBtn">REGISTER</Link>
                    </div>
                </div>
            </div>
            <section className='formBG mt-5'>
                <div className='container'>
                    <div className="formContent">
                    {tokenStatus !== 'valid' && (
                            <Card
                                sx={{
                                    maxWidth: 500,
                                    mx: 'auto',
                                    mt: 4,
                                    p: 3,
                                    boxShadow: 3,
                                    textAlign: 'center',
                                }}
                            >
                                <CardContent>
                                    {tokenStatus === null && (
                                        <Typography variant="h6" align="center">
                                            Loading...
                                        </Typography>
                                    )}
                                    {tokenStatus === 'expired' && (
                                        <Typography
                                            variant="h4"
                                            align="center"
                                            color="error"
                                            gutterBottom
                                        >
                                            Token Expired
                                        </Typography>
                                    )}
                                    {tokenStatus === 'invalid' && (
                                        <Typography
                                            variant="h4"
                                            align="center"
                                            color="error"
                                            gutterBottom
                                        >
                                            Invalid Token
                                        </Typography>
                                    )}
                                </CardContent>
                            </Card>
                        )}
                        {tokenStatus === 'valid' && (
                            <>
                                <h2>Reset Password</h2>
                                {message && (
                                    <Alert severity={success ? 'success' : 'error'} sx={{ mg: 2 }}>{message}</Alert>
                                )}

                                <Formik
                                    initialValues={{ password: '', confirmPassword: '' }}
                                    validationSchema={resetPasswordValidationSchema}
                                    onSubmit={handleSubmit}>

                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        isSubmitting,
                                    }) => (
                                        <div className='row justify-content-center align-items-center'>
                                            <div className="col-md-5">
                                                <div className="">
                                                    <Form style={{ width: '100%' }}>
                                                        <div className="otpBG">
                                                            <TextField
                                                                label="New Password"
                                                                name="password"
                                                                type={showPassword ? 'text' : 'password'}
                                                                value={values.password}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                fullWidth
                                                                margin="normal"
                                                                error={touched.password && !!errors.password}
                                                                helperText={touched.password && errors.password}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton
                                                                                onClick={() => setShowPassword(!showPassword)}
                                                                                edge="end"
                                                                            >
                                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                            <TextField
                                                                label='Confirm Password'
                                                                name='confirmPassword'
                                                                type='password'
                                                                value={values.confirmPassword}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                fullWidth
                                                                margin="normal"
                                                                error={touched.confirmPassword && !!errors.confirmPassword}
                                                                helperText={touched.confirmPassword && errors.confirmPassword}
                                                            />
                                                            <Button
                                                                type="submit"
                                                                variant="contained"
                                                                color="primary"
                                                                fullWidth
                                                                sx={{ mt: 2 }}
                                                                disabled={isSubmitting}
                                                                className="btn btn-primary btnCancel"
                                                            >
                                                                {isSubmitting ? 'Submitting...' : 'Set Password'}
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Formik>
                            </>
                        )}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}
